module.exports = __webpack_public_path__ + "ed000602ede7afbfccf98f8a844540a5.MP3";